// features/mainScreen/pages/MainScreen.tsx
import React, { useEffect, useState } from "react";
import {
  Box,
  Drawer,
  AppBar,
  Toolbar,
  List,
  Typography,
  Divider,
  IconButton,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useTheme,
  useMediaQuery,
  Avatar,
  Badge,
  Paper,
  Collapse,
  styled,
  Tooltip,
  Snackbar,
  Menu,
  MenuItem,
  Button
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import {
  AccessTime,
  Announcement,
  Assignment,
  DateRange,
  EventBusy,
  Fingerprint,
  HomeWork,
  Person,
  Schedule,
  School,
  Logout as LogoutIcon,
  Calculate,
  Dashboard,
  Sms,
  ExpandLess,
  ExpandMore,
  HowToReg,
  BarChart,
  Assessment,
  LockOutlined,
  ArrowDropDown
} from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";
import { KullaniciModal } from "../../../types/modals";
import { KullaniciTuru } from "../../../types/enums";
import { useInstitution } from "../../../contexts/InstitutionContext";
// Components
import DersProgrami from "./DersProgrami";
import Birebir from "./Birebir";
import Sinav from "./Sinav";
import Devamsizlik from "./Devamsizlik";
import Odevlerim from "./Odevlerim";
import YoklamaSistemi from "./YoklamaSistemi";
import OgretmenDersProgramim from "./OgretmenDersProgramim";
import OgretmenBirebir from "./OgretmenBirebir";
import DashboardPage from "./DashboardPage";
import OgrenciMuhasebeIslemleri from "./OgrenciMuhasebeIslemleri";
import OgrenciSMSIslemleri from "./OgrenciSMSIslemleri";
import Duyurular from "./Duyurular";
import OgrenciDuyuru from "./OgrenciDuyuru";
import ParmakIzi from "./ParmakIzi";
import BirebirOgretmen from "./BirebirOgretmen";
import YoklamaRaporu from "./YoklamaRaporu";
import BirebirRaporlari from "./BirebirRaporlari";
import SinavRaporlari from "./SinavRaporlari";
import TercihRobotu from "../../../components/TercihRobotu";
import FinalSinav from "./FinalSinav";
import OgretmenSinavKarne from "./OgretmenSinavKarne";
const drawerWidth = 260;
// Permission mapping for menu items
const permissionMapping: Record<string, keyof KullaniciModal> = {
  // Yönetim category
  "Raporlar": "MobilMuhasebeRaporlari",
  "Öğrenci Muhasebe İşlemleri": "OgrenciMuhasebeIslemleriGoruntuleme",
  "Öğrenci SMS Gönder": "SerbestSmsGonderme",

  // Raporlar category
  "Yoklama Raporu": "DevamsizlikGirisleri",
  "Birebir Raporları": "OgretmenDersProgramiDuzenleme",
  "Sınav Raporları": "SinavIslemleri",
};

// Öğrenci menü öğelerini kurum ID'sine göre döndüren fonksiyon
const getOgrenciMenuItems = (institutionId: string) => {
  // ftest kurumu için özel menü
  if (institutionId === "ftest") {
    return [
      {
        category: "BİLGİLENDİRME",
        items: [
          { text: "Sınavlarım", icon: <Assignment />, badge: 0 },
        ]
      }
    ];
  }

  // Diğer kurumlar için standart menü
  return [
    {
      category: "DERS VE ETÜT",
      items: [
        { text: "Ders Programım", icon: <Schedule />, badge: 0 },
        { text: "Birebir Etütlerim", icon: <Person />, badge: 0 },
        { text: "Ödevlerim", icon: <HomeWork />, badge: 0 },
      ]
    },
    {
      category: "BİLGİLENDİRME",
      items: [
        { text: "Öğrenci Duyuruları", icon: <School />, badge: 0 },
        { text: "Sınavlarım", icon: <Assignment />, badge: 0 },
      ]
    },
    {
      category: "DEVAMSIZLIK",
      items: [
        { text: "Devamsızlık Takibi (Öğretmen)", icon: <EventBusy />, badge: 0 },
        { text: "Devamsızlık Takibi (Saatlik)", icon: <AccessTime />, badge: 0 },
        { text: "Devamsızlık Takibi (Günlük)", icon: <DateRange />, badge: 0 },
        { text: "Parmak İzi Geçiş Detayları", icon: <Fingerprint />, badge: 0 },
      ]
    }
  ];
};

const getOgretmenMenuItems = (institutionId: string) => {
  // ftest kurumu için özel menü
  if (institutionId === "ftest") {
    return [
      {
        category: "BİLGİLENDİRME",
        items: [
          { text: "Sınav Raporları", icon: <Assignment />, badge: 0 },
        ]
      }
    ];
  }

  return [
    {
      category: "Ders Yönetimi",
      items: [
        { text: "Yoklama Sistemi", icon: <Schedule />, badge: 0 },
        { text: "Ders Programım", icon: <Person />, badge: 0 },
        { text: "Birebir Etütlerim", icon: <HomeWork />, badge: 0 },
      ]
    },
    {
      category: "Raporlar",
      items: [
        { text: "Sınav Raporları", icon: <Assessment />, badge: 0 },
      ]
    },
    {
      category: "İletişim",
      items: [
        { text: "Duyurular", icon: <Announcement />, badge: 0 },
      ]
    },
    {
      category: "Tercih Robotu",
      items: [
        { text: "Ön Lisans", icon: <School />, badge: 0 },
      ]
    }
  ];
}

// Admin menu items with permission keys
const idareMenuItems = [
  {
    category: "Yönetim",
    items: [
      {
        text: "Raporlar",
        icon: <Dashboard />,
        badge: 0,
        permission: "mobilMuhasebeRaporlari" as keyof KullaniciModal
      },
      {
        text: "Öğrenci Muhasebe İşlemleri",
        icon: <Calculate />,
        badge: 0,
        permission: "ogrenciMuhasebeIslemleriGoruntuleme" as keyof KullaniciModal
      },
      {
        text: "Öğrenci SMS Gönder",
        icon: <Sms />,
        badge: 0,
        permission: "kayitliOgrenciVeOgretmenlereSmsGonderme" as keyof KullaniciModal
      },
    ]
  },
  {
    category: "Raporlar",
    items: [
      {
        text: "Yoklama Raporu",
        icon: <HowToReg />,
        badge: 0,
        permission: "devamsizlikGirisleri" as keyof KullaniciModal
      },
      {
        text: "Birebir Raporları",
        icon: <BarChart />,
        badge: 0,
        permission: "devamsizlikGirisleri" as keyof KullaniciModal
      }
    ]
  }
];
const MainScreen: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const { institution, selectedSubInstitution, setSelectedSubInstitution, hasSubInstitutions } = useInstitution();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const [mobileOpen, setMobileOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<string>("");
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedSubIndex, setSelectedSubIndex] = useState(0);
  const [expandedCategories, setExpandedCategories] = useState<Record<string, boolean>>({});
  const [permissionDenied, setPermissionDenied] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  // Alt kurum seçim menüsü için state
  const [subInstitutionMenuAnchor, setSubInstitutionMenuAnchor] = useState<null | HTMLElement>(null);

  const currentUser = (localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '{}') : {}) as KullaniciModal;

  // Kurum renklerini kullanarak dinamik renkler oluştur
  const adjustBrightness = (color: string, percent: number, lighten = false): string => {
    // Hex rengi RGB'ye dönüştür
    let r = parseInt(color.substring(1, 3), 16);
    let g = parseInt(color.substring(3, 5), 16);
    let b = parseInt(color.substring(5, 7), 16);

    // Parlaklığı ayarla
    if (lighten) {
      // Rengi açma işlemi (daha açık renk için)
      r = Math.min(255, r + Math.round(255 * (percent / 100)));
      g = Math.min(255, g + Math.round(255 * (percent / 100)));
      b = Math.min(255, b + Math.round(255 * (percent / 100)));
    } else {
      // Rengi koyulaştırma veya açma işlemi
      r = Math.max(0, Math.min(255, r + Math.round(r * (percent / 100))));
      g = Math.max(0, Math.min(255, g + Math.round(g * (percent / 100))));
      b = Math.max(0, Math.min(255, b + Math.round(b * (percent / 100))));
    }

    // RGB'yi hex'e dönüştür
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  };

  const COLORS = {
    primary: institution.primaryColor,
    primaryLight: institution.secondaryColor || adjustBrightness(institution.primaryColor, 20),
    primaryDark: adjustBrightness(institution.primaryColor, -20),
    secondary: institution.secondaryColor || '#6e6e6e',
    secondaryDark: adjustBrightness(institution.secondaryColor || '#6e6e6e', -20),
    secondaryLight: adjustBrightness(institution.secondaryColor || '#6e6e6e', 20),
    hover: adjustBrightness(institution.primaryColor, 40, true),
    white: '#ffffff',
    background: '#f5f5f5',
    divider: 'rgba(0, 0, 0, 0.12)',
    textPrimary: '#333333',
    textSecondary: '#666666',
    success: '#4caf50',
    warning: '#ff9800',
    error: '#f44336'
  };

  // Styled Components - Dinamik renklerle
  const StyledAppBar = styled(AppBar)(() => ({
    backgroundColor: COLORS.primary,
    boxShadow: `0 4px 12px rgba(0, 0, 0, 0.15)`,
    zIndex: theme.zIndex.drawer + 1,
    transition: 'width 0.3s ease, margin 0.3s ease',
    '& .MuiToolbar-root': {
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0 16px',
    },
  }));

  const StyledToolbar = styled(Toolbar)(() => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: '64px',
    padding: '0 16px',
    [theme.breakpoints.down('sm')]: {
      minHeight: '56px',
      padding: '0 8px',
    },
  }));

  const StyledDrawer = styled(Drawer)(() => ({
    width: drawerWidth,
    flexShrink: 0,
    '& .MuiDrawer-paper': {
      width: drawerWidth,
      boxSizing: 'border-box',
      backgroundColor: COLORS.white,
      borderRight: `1px solid ${COLORS.divider}`,
      boxShadow: '2px 0 10px rgba(0,0,0,0.05)',
      transition: 'width 0.3s ease',
      overflowX: 'hidden',
      paddingTop: '64px',
      [theme.breakpoints.down('sm')]: {
        paddingTop: '56px',
      },
    },
  }));

  const StyledListItemButton = styled(ListItemButton)(() => ({
    '&.Mui-selected': {
      backgroundColor: COLORS.primary,
      color: COLORS.white,
      fontWeight: 500,
      '&:hover': {
        backgroundColor: COLORS.primaryDark,
      },
      '& .MuiListItemIcon-root': {
        color: COLORS.white,
      },
      '&::before': {
        content: '""',
        position: 'absolute',
        left: 0,
        top: '20%',
        height: '60%',
        width: 4,
        backgroundColor: COLORS.white,
        borderRadius: '0 4px 4px 0',
      },
    },
    '&:hover': {
      backgroundColor: COLORS.hover,
      '& .MuiListItemIcon-root': {
        transform: 'scale(1.1)',
      },
    },
    borderRadius: '8px',
    margin: '4px 8px',
    padding: '8px 16px',
    transition: 'all 0.2s ease',
    position: 'relative',
    overflow: 'hidden',
  }));

  const UserMenuButton = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '4px 12px',
    borderRadius: '20px',
    cursor: 'pointer',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
    },
  }));

  const Logo = styled('img')({
    height: '36px',
    width: 'auto',
    filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))',
    transition: 'transform 0.3s ease',
    '&:hover': {
      transform: 'scale(1.05)',
    },
  });

  const StyledLogoutButton = styled(ListItemButton)(() => ({
    margin: '8px',
    padding: '10px 16px',
    color: theme.palette.error.main,
    borderRadius: '8px',
    backgroundColor: 'rgba(244, 67, 54, 0.05)',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(244, 67, 54, 0.1)',
      color: theme.palette.error.dark,
      transform: 'translateY(-2px)',
    },
    '& .MuiListItemIcon-root': {
      color: 'inherit',
      minWidth: '40px',
      transition: 'transform 0.2s ease',
    },
    '&:hover .MuiListItemIcon-root': {
      transform: 'rotate(90deg)',
    },
    '& .MuiListItemText-primary': {
      fontWeight: 500,
    },
  }));

  const ContentContainer = styled(Box)(() => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    backgroundColor: COLORS.background,
    minHeight: '100vh',
    transition: 'padding 0.3s ease',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  }));

  const PageHeader = styled(Box)(() => ({
    marginBottom: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
  }));

  const PageTitle = styled(Typography)(() => ({
    color: COLORS.primary,
    fontWeight: 600,
    fontSize: '1.5rem',
    marginBottom: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.25rem',
    },
  }));

  const StyledDivider = styled(Divider)(() => ({
    borderColor: COLORS.primaryLight,
    opacity: 0.7,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  }));

  const UserAvatar = styled(Avatar)(() => ({
    backgroundColor: COLORS.white,
    color: COLORS.primary,
    fontWeight: 'bold',
    width: 32,
    height: 32,
    fontSize: '1rem',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    border: `2px solid ${COLORS.white}`,
  }));

  const MenuSection = styled(Box)(() => ({
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    padding: '0 16px',
  }));

  const MenuSectionTitle = styled(Typography)(() => ({
    color: COLORS.textSecondary,
    fontSize: '0.75rem',
    fontWeight: 500,
    textTransform: 'uppercase',
    letterSpacing: '0.1em',
  }));

  const SubInstitutionButton = styled(Button)(() => ({
    color: COLORS.white,
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderRadius: '20px',
    padding: '4px 12px',
    fontSize: '0.8rem',
    textTransform: 'none',
    marginLeft: '8px',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
    },
  }));

  // Permission Denied Component
  const PermissionDenied: React.FC = () => (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
        textAlign: 'center'
      }}
    >
      <Box sx={{ mb: 3 }}>
        <IconButton
          disabled
          sx={{
            backgroundColor: 'rgba(244, 67, 54, 0.1)',
            p: 2,
            '&.Mui-disabled': { opacity: 1 }
          }}
        >
          <LockOutlined sx={{ fontSize: 40, color: COLORS.error }} />
        </IconButton>
      </Box>
      <Typography variant="h5" color="error" gutterBottom>
        Erişim Engellendi
      </Typography>
      <Typography variant="body1" color="textSecondary" sx={{ maxWidth: 500, mb: 3 }}>
        Bu sayfayı görüntülemek için gerekli yetkilere sahip değilsiniz.
        Erişim gerekiyorsa lütfen sistem yöneticinize başvurun.
      </Typography>
    </Box>
  );

  // Alt kurum seçimi menüsünü aç/kapat
  const handleSubInstitutionMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setSubInstitutionMenuAnchor(event.currentTarget);
  };

  const handleSubInstitutionMenuClose = () => {
    setSubInstitutionMenuAnchor(null);
  };

  // Alt kurum değiştirme
  const handleSubInstitutionChange = (subId: string) => {
    const subInst = institution.subInstitutions?.find(s => s.id === subId) || null;
    setSelectedSubInstitution(subInst);
    handleSubInstitutionMenuClose();
  };

  // Function to filter menu items based on user permissions
  const getIdareMenuItemsForUser = (user: KullaniciModal) => {
    // If you want to show all items but disable those without permission:
    return idareMenuItems;
  };

  // Get current menu items based on user type
  const getCurrentMenuItems = () => {
    if (currentUser.kullaniciTuru?.toString() === "Ogrenci") {
      return getOgrenciMenuItems(institution.id);
    } else if (currentUser.kullaniciTuru?.toString() === "Ogretmen") {
      return getOgretmenMenuItems(institution.id);
    } else {
      return getIdareMenuItemsForUser(currentUser);
    }
  };

  // Check if user has permission for a specific menu item
  const hasPermission = (menuText: string): boolean => {
    // Only check permissions for admin users
    if (currentUser.kullaniciTuru?.toString() !== "Idare") {
      return true;
    }

    // Find the menu item in idareMenuItems
    for (const category of idareMenuItems) {
      for (const item of category.items) {
        if (item.text === menuText && item.permission) {
          return Boolean(currentUser[item.permission]);
        }
      }
    }

    // Fallback to the permission mapping
    const permissionKey = permissionMapping[menuText];
    if (!permissionKey) return true; // If no mapping exists, allow by default

    return Boolean(currentUser[permissionKey]);
  };

  // Get the permission key for a menu item (for display purposes)
  const getPermissionKeyForMenuItem = (menuText: string): string | null => {
    // Find the menu item in idareMenuItems
    for (const category of idareMenuItems) {
      for (const item of category.items) {
        if (item.text === menuText && item.permission) {
          return item.permission as string;
        }
      }
    }

    // Fallback to the permission mapping
    return permissionMapping[menuText] as string || null;
  };

  // Initialize expanded categories
  useEffect(() => {
    const menuItems = getCurrentMenuItems();
    const initialExpanded: Record<string, boolean> = {};
    menuItems.forEach(category => {
      initialExpanded[category.category] = true;
    });
    setExpandedCategories(initialExpanded);

    // Set initial selected category
    if (menuItems.length > 0 && menuItems[0].items.length > 0) {
      setSelectedCategory(menuItems[0].category);
    }

    // Reset permission denied state when user changes
    setPermissionDenied(false);
  }, [currentUser.kullaniciTuru]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleCategoryToggle = (category: string) => {
    setExpandedCategories(prev => ({
      ...prev,
      [category]: !prev[category]
    }));
  };

  const handleListItemClick = (categoryIndex: number, itemIndex: number, category: string) => {
    const menuItems = getCurrentMenuItems();
    const menuItem = menuItems[categoryIndex].items[itemIndex];

    // Check permission before navigating
    if (!hasPermission(menuItem.text)) {
      setPermissionDenied(true);

      // Show snackbar with permission message
      const permissionKey = getPermissionKeyForMenuItem(menuItem.text);
      setSnackbarMessage(`Bu özelliğe erişmek için "${permissionKey}" yetkisi gerekiyor.`);
      setSnackbarOpen(true);

      if (isMobile) {
        setMobileOpen(false);
      }
      return;
    }

    // If has permission, proceed normally
    setPermissionDenied(false);
    setSelectedCategory(category);
    setSelectedIndex(categoryIndex);
    setSelectedSubIndex(itemIndex);

    if (isMobile) {
      setMobileOpen(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/login');
  };

  // Get current page title
  const getCurrentPageTitle = () => {
    const menuItems = getCurrentMenuItems();
    for (let i = 0; i < menuItems.length; i++) {
      const category = menuItems[i];
      for (let j = 0; j < category.items.length; j++) {
        if (i === selectedIndex && j === selectedSubIndex) {
          return category.items[j].text;
        }
      }
    }
    return "Dashboard";
  };

  // Get current page icon
  const getCurrentPageIcon = () => {
    const menuItems = getCurrentMenuItems();
    for (let i = 0; i < menuItems.length; i++) {
      const category = menuItems[i];
      for (let j = 0; j < category.items.length; j++) {
        if (i === selectedIndex && j === selectedSubIndex) {
          return category.items[j].icon;
        }
      }
    }
    return <Dashboard />;
  };

  // Drawer content
  const drawer = (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box sx={{ flexGrow: 1, overflowY: 'auto', overflowX: 'hidden' }}>
        {/* Alt kurum bilgisini göster */}
        {selectedSubInstitution && (
          <Box sx={{ p: 2, pb: 0 }}>
            <Paper
              elevation={0}
              sx={{
                p: 1.5,
                backgroundColor: COLORS.primaryLight,
                borderRadius: '8px',
                color: '#fff',
                textAlign: 'center',
                fontSize: '0.85rem',
                fontWeight: 500
              }}
            >
              {selectedSubInstitution.name}
            </Paper>
          </Box>
        )}

        {getCurrentMenuItems().map((category, categoryIndex) => (
          <Box key={category.category}>
            <MenuSection>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  cursor: 'pointer',
                  py: 0.5,
                }}
                onClick={() => handleCategoryToggle(category.category)}
              >
                <MenuSectionTitle>{category.category}</MenuSectionTitle>
                <IconButton size="small" sx={{ p: 0.5 }}>
                  {expandedCategories[category.category] ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
                </IconButton>
              </Box>
            </MenuSection>
            <Collapse in={expandedCategories[category.category]} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {category.items.map((item, itemIndex) => {
                  // For admin users, check if they have permission for this menu item
                  const hasMenuPermission = hasPermission(item.text);
                  const permissionKey = currentUser.kullaniciTuru?.toString() === "Idare" ?
                    getPermissionKeyForMenuItem(item.text) : null;

                  return (
                    <Tooltip
                      key={item.text}
                      title={!hasMenuPermission && permissionKey ?
                        `Bu özelliğe erişmek için "${permissionKey}" yetkisi gerekiyor.` : ""}
                      placement="right"
                      arrow
                    >
                      <div> {/* Wrapper div needed for disabled buttons with tooltips */}
                        <StyledListItemButton
                          selected={selectedIndex === categoryIndex && selectedSubIndex === itemIndex}
                          onClick={() => handleListItemClick(categoryIndex, itemIndex, category.category)}
                          sx={{
                            // Apply opacity to menu items without permission
                            opacity: hasMenuPermission ? 1 : 0.5,
                            position: 'relative',
                            // Add a lock icon indicator for items without permission
                            '&::after': !hasMenuPermission ? {
                              content: '""',
                              position: 'absolute',
                              right: 8,
                              width: 16,
                              height: 16,
                              backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'%23999\'%3E%3Cpath d=\'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z\'/%3E%3C/svg%3E")',
                              backgroundSize: 'contain',
                              backgroundRepeat: 'no-repeat',
                            } : {},
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              color: selectedIndex === categoryIndex && selectedSubIndex === itemIndex ? COLORS.white : COLORS.primary,
                              minWidth: "40px",
                              transition: 'transform 0.2s ease',
                              opacity: hasMenuPermission ? 1 : 0.6,
                            }}
                          >
                            {item.icon}
                          </ListItemIcon>
                          <ListItemText
                            primary={item.text}
                            primaryTypographyProps={{
                              fontSize: '0.9rem',
                              fontWeight: selectedIndex === categoryIndex && selectedSubIndex === itemIndex ? 500 : 400,
                              noWrap: true,
                            }}
                          />
                          {item.badge > 0 && (
                            <Badge
                              badgeContent={item.badge}
                              color="error"
                              sx={{
                                '& .MuiBadge-badge': {
                                  fontSize: '0.7rem',
                                  height: 18,
                                  minWidth: 18,
                                }
                              }}
                            />
                          )}
                        </StyledListItemButton>
                      </div>
                    </Tooltip>
                  );
                })}
              </List>
            </Collapse>
            <Divider sx={{ my: 1, opacity: 0.6 }} />
          </Box>
        ))}
      </Box>
      <Box sx={{ p: 2 }}>
        <StyledLogoutButton onClick={handleLogout}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Çıkış Yap" />
        </StyledLogoutButton>
      </Box>
    </Box>
  );

  // Render the content based on selected menu item
  const renderContent = () => {
    // If permission is denied, show the permission denied component
    if (permissionDenied) {
      return <PermissionDenied />;
    }

    // Get the currently selected menu item
    const menuItems = getCurrentMenuItems();
    if (selectedIndex < menuItems.length) {
      const category = menuItems[selectedIndex];
      if (selectedSubIndex < category.items.length) {
        const menuItem = category.items[selectedSubIndex];

        // Check if user has permission for this content
        if (currentUser.kullaniciTuru?.toString() === "Idare" && !hasPermission(menuItem.text)) {
          return <PermissionDenied />;
        }
      }
    }

    // If user has permission, render the appropriate content
    if (currentUser.kullaniciTuru?.toString() === "Ogrenci") {
      // Eğer ftest kurumu ise, doğrudan Sinav bileşenini göster
      if (institution.id === "ftest") {
        return <FinalSinav />;
      }

      // Diğer kurumlar için normal mantığı uygula
      let flatIndex = 0;
      for (let i = 0; i < selectedIndex; i++) {
        flatIndex += getOgrenciMenuItems(institution.id)[i].items.length;
      }
      flatIndex += selectedSubIndex;

      switch (flatIndex) {
        case 0: return <DersProgrami />;
        case 1: return <Birebir />;
        case 2: return <Odevlerim />;
        case 3: return <OgrenciDuyuru />;
        case 4: return <Sinav />;
        case 5:
        case 6:
        case 7: return <Devamsizlik />;
        case 8: return <ParmakIzi />;
        default:
          return (
            <Typography paragraph>
              Seçilen menü içeriği burada gösterilecek.
            </Typography>
          );
      }
    } else if (currentUser.kullaniciTuru?.toString() === "Ogretmen") {
      // Eğer ftest kurumu ise, doğrudan Sinav bileşenini göster
      if (institution.id === "ftest") {
        return <OgretmenSinavKarne />;
      }

      // Diğer kurumlar için normal mantığı uygula
      let flatIndex = 0;
      for (let i = 0; i < selectedIndex; i++) {
        flatIndex += getOgretmenMenuItems(institution.id)[i].items.length;
      }
      flatIndex += selectedSubIndex;

      switch (flatIndex) {
        case 0: return <YoklamaSistemi />;
        case 1: return <OgretmenDersProgramim />;
        case 2: return <BirebirOgretmen />;
        case 3: return <SinavRaporlari />;
        case 4: return <Duyurular />;
        case 5: return <TercihRobotu />;
        default:
          return (
            <Typography paragraph>
              Seçilen menü içeriği burada gösterilecek.
            </Typography>
          );
      }
    } else if (currentUser.kullaniciTuru?.toString() === "Idare") {
      // Flatten the menu structure for admin
      let flatIndex = 0;
      for (let i = 0; i < selectedIndex; i++) {
        flatIndex += getIdareMenuItemsForUser(currentUser)[i].items.length;
      }
      flatIndex += selectedSubIndex;

      switch (flatIndex) {
        case 0: return <DashboardPage />;
        case 1: return <OgrenciMuhasebeIslemleri />;
        case 2: return <OgrenciSMSIslemleri />;
        case 3: return <YoklamaRaporu />;
        case 4: return <BirebirRaporlari />;
        default:
          return (
            <Typography paragraph>
              Seçilen menü içeriği burada gösterilecek.
            </Typography>
          );
      }
    }

    return <Typography paragraph>İçerik bulunamadı.</Typography>;
  };
  return (
    <Box sx={{ display: "flex" }}>
      <StyledAppBar position="fixed">
        <StyledToolbar>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{
                color: COLORS.white,
                mr: 1,
              }}
            >
              <MenuIcon />
            </IconButton>

            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Logo
                  src={institution.logo || "/beyazLogo.png"}
                  alt={`${institution.name} Logo`}
                  sx={{ display: 'flex', alignItems: 'center', height: '28px' }}
                  onError={(e) => {
                    // Logo yüklenemezse varsayılan logoyu göster
                    const target = e.target as HTMLImageElement;
                    target.src = '/beyazLogo.png';
                  }}
                />

                {/* Alt kurum seçim butonu - sadece alt kurumları varsa göster */}
                {hasSubInstitutions && currentUser.kullaniciTuru?.toString() === "Idare" && (
                  <>
                    <SubInstitutionButton
                      endIcon={<ArrowDropDown />}
                      onClick={handleSubInstitutionMenuOpen}
                    >
                      {selectedSubInstitution?.name || "Kurum Seç"}
                    </SubInstitutionButton>

                    <Menu
                      anchorEl={subInstitutionMenuAnchor}
                      open={Boolean(subInstitutionMenuAnchor)}
                      onClose={handleSubInstitutionMenuClose}
                      sx={{
                        '& .MuiPaper-root': {
                          borderRadius: '8px',
                          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                          mt: 1,
                        }
                      }}
                    >
                      {institution.subInstitutions?.map((subInst) => (
                        <MenuItem
                          key={subInst.id}
                          onClick={() => handleSubInstitutionChange(subInst.id)}
                          selected={selectedSubInstitution?.id === subInst.id}
                          sx={{
                            minWidth: '200px',
                            fontSize: '0.9rem',
                            py: 1,
                            '&.Mui-selected': {
                              backgroundColor: COLORS.hover,
                              fontWeight: 500,
                            },
                            '&:hover': {
                              backgroundColor: COLORS.hover,
                            }
                          }}
                        >
                          {subInst.name}
                        </MenuItem>
                      ))}
                    </Menu>
                  </>
                )}
              </Box>

              {/* Alt kurum adını göster - mobil olmayan cihazlarda */}
              {!isMobile && selectedSubInstitution && (
                <Typography
                  variant="caption"
                  sx={{
                    color: 'rgba(255,255,255,0.8)',
                    fontSize: '0.7rem',
                    mt: -0.5
                  }}
                >
                  {selectedSubInstitution.name}
                </Typography>
              )}
            </Box>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <UserMenuButton onClick={handleLogout}>
              <UserAvatar>
                {currentUser.adSoyad?.charAt(0) || 'U'}
              </UserAvatar>
              {!isMobile && (
                <Typography variant="body2" color="white" noWrap sx={{ maxWidth: 120 }}>
                  {currentUser.adSoyad}
                </Typography>
              )}
            </UserMenuButton>
          </Box>
        </StyledToolbar>
      </StyledAppBar>

      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
      >
        {/* Mobile drawer */}
        <StyledDrawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{ display: { xs: "block", sm: "none" } }}
        >
          {drawer}
        </StyledDrawer>
        {/* Desktop drawer */}
        <StyledDrawer
          variant="permanent"
          sx={{ display: { xs: "none", sm: "block" } }}
          open
        >
          {drawer}
        </StyledDrawer>
      </Box>

      <Box
        component="main"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          flexGrow: 1,
        }}
      >
        <ContentContainer
          sx={{
            marginTop: '64px', // Add top margin to account for AppBar height
          }}
        >
          <PageHeader>
            <PageTitle>
              {getCurrentPageIcon()}
              {getCurrentPageTitle()}
            </PageTitle>
            <StyledDivider />
          </PageHeader>
          <Paper
            elevation={0}
            sx={{
              borderRadius: 3,
              overflow: 'hidden',
              boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
              p: { xs: 2, sm: 3 },
              backgroundColor: COLORS.white,
            }}
          >
            {renderContent()}
          </Paper>
        </ContentContainer>
      </Box>

      {/* Permission denied snackbar */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        action={
          <IconButton
            size="small"
            color="inherit"
            onClick={() => setSnackbarOpen(false)}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
        sx={{
          '& .MuiSnackbarContent-root': {
            backgroundColor: COLORS.error,
            color: COLORS.white,
          }
        }}
      />
    </Box>
  );
};
export default MainScreen;